module.exports = __webpack_public_path__ + "static/media/0401.532a7c6d.png";